import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { readCiRelation, readCiRelations } from "../services/ciRelationsApi";

export function useCiRelationQuery(publicId, enabled = true) {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["ci_relation", publicId],
    queryFn: () => readCiRelation(publicId),
    enabled: enabled && !!publicId,
    gcTime: 0,
    onError: (error) => {
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });
}

export function useCiRelationsQuery(params, enabled = true) {
  return useQuery({
    queryKey: ["ci_relations", params],
    queryFn: () => readCiRelations(params),
    enabled,
  });
}
